export default __webpack_public_path__ + "static/media/openBg.0eb55500.svg";